import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'
import { colors } from '../../constants'

export const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: auto;
  }
`

export const Container = styled.div`
    align-items: center;
    color: ${colors.blue};
    display: flex;
    font-size: 1.25em;
    flex-direction: column;
    height: 100vh;
    justify-content: start;
    width: 100%;
`

export const Description = styled.div`
    background: ${colors.blue};
    color: ${colors.white};
    margin-bottom: 20px;
    padding: 10px 40px;
    text-align: center;
    width: 100%;

    & > h1 {
        font-size: 1.25em;
    }

    & > a {
        color: ${colors.white} !important;
        margin: 4px;
    }

    & > a:visited {
        color: ${colors.white} !important;
    }
`

export const MessageBoard = styled.div`
    height: 180px;
    padding: 20px 50px;
    text-align: center;
`

export const ErrorMessage = styled.span`
    color: ${colors.red};
`

export const SuccessMessage = styled.div`
    color: ${colors.blue};
    margin-top: 10px;
`

export const InputGroup = styled.div`
    padding: 20px;
`

export const Label = styled.label`
    display: block;
`

export const Input = styled.input`
    padding: 10px;
`

export const Button = styled.button`
    background: ${colors.blue};
    color: ${colors.white};
    border: none;
    border-radius: 10px;
    font-size: 1em;
    padding: 20px 30px;
    margin-bottom: 30px;

    &:focus,
    &:hover {
    }

    ${({ disabled }) => disabled && `background: ${colors.greylight};`};
`
